import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";

import { HashRouter } from "react-router-dom";
import "./assets/base.scss";
import Main from "./Pages/Main";
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";
import { setDefaultLocale } from "react-datepicker";
import { ja } from "date-fns/locale";

// Apollo Client
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import GoogleAnalyticsWrapper from "./components/GoogleAnalyticsWrapper";

setDefaultLocale(ja);

setDefaultLocale(ja);
const client = new ApolloClient({
  uri: process.env.REACT_APP_API_URL,
  headers: {
    authorization: localStorage.getItem("token")
      ? `JWT ${localStorage.getItem("token")}`
      : "",
  },
  cache: new InMemoryCache(),
});

const store = configureStore();
const rootElement = document.getElementById("root");

// 大元のレンダリングコンポーネント
const renderApp = (Component) => {
  ReactDOM.render(
    <ApolloProvider client={client}>
      <Provider store={store}>
        <HashRouter>
          <GoogleAnalyticsWrapper>
            <Component />
          </GoogleAnalyticsWrapper>
        </HashRouter>
      </Provider>
    </ApolloProvider>,
    rootElement
  );
};

// Mainをブラウザにレンダリング
renderApp(Main);

if (module.hot) {
  module.hot.accept("./Pages/Main", () => {
    const NextApp = require("./Pages/Main").default;
    renderApp(NextApp);
  });
}
serviceWorker.unregister();
